<h2 class="show-for-medium">Not Authorized</h2>
<hr class="divider show-for-medium">
<p>
  Oops, it doesn't look like you are authorized to use this application via UCR's Enterprise Access Control System (EACS). Please contact your UCR System Access Administrator (SAA) if you believe
  you are receiving this message in error.
</p>